var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame156(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.10136,
    y: 1.2808,
    width: 42.9257,
    height: 42.9257,
    rx: 21.4629,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.10066
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8487 17.7239L22.5675 23.3482L32.2203 17.7569",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.65099,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5675 33.3204V23.3374",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.65099,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2892 12.2648L14.4117 15.5228C13.0799 16.2602 11.9902 18.1093 11.9902 19.6282V25.8469C11.9902 27.3659 13.0799 29.215 14.4117 29.9524L20.2892 33.2214C21.544 33.9148 23.6022 33.9148 24.8569 33.2214L30.7345 29.9524C32.0663 29.215 33.1559 27.3659 33.1559 25.8469V19.6282C33.1559 18.1093 32.0663 16.2602 30.7345 15.5228L24.8569 12.2538C23.5912 11.5604 21.544 11.5604 20.2892 12.2648Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.65099,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame156);
export default __webpack_public_path__ + "static/media/Frame 156.628eff24ce33480cefbcb1f7489b2030.svg";
export { ForwardRef as ReactComponent };